/**
 * A party's display name from the identity graph, for the screen. Mirrors
 * `partyName` in `@cordelia/pipeline`: the card cannot import the pipeline,
 * and the app's main-thread bundle stays free of it.
 */
import type { IdentityGraph, Party } from '@cordelia/core'

export function partyName(party: Party, graph: IdentityGraph): string {
  if (party === 'unresolved') return 'someone'
  const person = graph.persons.find((p) => p.id === party)
  if (person) return person.display_names[0] ?? person.addresses[0] ?? 'someone'
  const org = graph.organizations.find((o) => o.id === party)
  if (org) return org.name ?? org.domains[0] ?? 'the organization'
  return 'someone'
}
